import { createFileRoute, Link } from "@tanstack/react-router";
import { useCurrentModule } from "@contexts/ModuleContext.tsx";
import { AppTabList, type TabType } from "@components/AppTabList.tsx";
import AppCard from "@components/AppCard.tsx";
import ModuleForm from "@components/modules/ModuleForm.tsx";
import { TabPanel, TabContext } from "@mui/lab";
import { Tab, Stack } from "@mui/material";
import AdminQuestionnaireTab from "@components/modules/questionnaire/AdminQuestionnaireTab.tsx";
import ParticipationTab from "@components/modules/participations/ParticipationTab.tsx";
import ModuleDocumentsTab from "@components/modules/documents/ModuleDocumentsTab.tsx";
import { Icon } from "@iconify/react";
import { requireRole } from "@/auth/requireRole.ts";
import { ROLE_ADMIN } from "@/constants";

export const Route = createFileRoute("/_dashboard/modules/$uuid/$tab")({
  component: RouteComponent,
});

function RouteComponent() {
  const currentModule = useCurrentModule();

  const TABS: TabType[] = [
    {
      label: "Informations",
      value: "overview",
      href: `/modules/${currentModule.uuid}/overview`,
      icon: "tabler:file-text",
      children: (
        <AppCard>
          <ModuleForm />
        </AppCard>
      ),
    },
    {
      label: "Formulaire",
      value: "formulaire",
      href: `/modules/${currentModule.uuid}/formulaire`,
      icon: "tabler:box",
      children: <AdminQuestionnaireTab />,
    },
    {
      label: "Participations",
      value: "participations",
      href: `/modules/${currentModule.uuid}/participations`,
      icon: "tabler:users",
      dataPw: "participations-tab",
      children: (
        <AppCard>
          <ParticipationTab />
        </AppCard>
      ),
    },
    {
      label: "Documents",
      value: "documents",
      href: `/modules/${currentModule.uuid}/documents`,
      icon: "tabler:files",
      children: (
        <AppCard>
          <ModuleDocumentsTab />
        </AppCard>
      ),
    },
  ];

  const { tab } = Route.useParams();

  return (
    <TabContext value={tab}>
      <AppTabList>
        {TABS.map((tab) => (
          <Tab
            component={Link}
            key={tab.value}
            label={tab.label}
            value={tab.value}
            href={tab.href ?? tab.value}
            {...(tab.icon && {
              icon: <Icon fontSize="18" icon={tab.icon} />,
            })}
            iconPosition={"start"}
            data-pw={tab.dataPw}
          />
        ))}
      </AppTabList>
      {TABS.map((tab) => (
        <TabPanel
          value={tab.value}
          key={tab.value}
          sx={{
            padding: 0,
          }}
        >
          {tab.children}
        </TabPanel>
      ))}
    </TabContext>
  );
}
